import { FORTA_SUCCESS } from '../../utils/colors';

import type { IconProps } from './types';

const ConfirmIcon = (props: IconProps) => {
  const { color = FORTA_SUCCESS, width = 24, height = 24, viewBox = '0 0 24 24' } = props;

  return (
    <svg
      width={`${width}`}
      height={`${height}`}
      viewBox={`${viewBox}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21 4L12.0625 15L8 10"
        stroke={`${color}`}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.776 1.22748C12.37 0.741677 9.87164 1.03847 7.64637 2.07444C5.42111 3.11041 3.58569 4.83122 2.40859 6.98516C1.23148 9.13911 0.774446 11.6132 1.10433 14.0455C1.4342 16.4778 2.53369 18.7408 4.24197 20.5034C5.95025 22.2661 8.17769 23.4358 10.5985 23.8417C13.0193 24.2476 15.5065 23.8682 17.6962 22.7591C19.886 21.65 21.6634 19.8694 22.7685 17.6776C23.8736 15.4859 24.2485 12.998 23.8382 10.578"
        stroke={`${color}`}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ConfirmIcon;
